export const layouts = [
  [
    'col-span-9 row-span-4',
    'row-span-6 col-span-4',
    'row-span-3 col-span-5',
    'row-span-3 col-span-5',
  ],
  [
    'col-span-9 row-span-4',
    'row-span-3 col-span-5',
    'row-span-6 col-span-4',
    'row-span-3 col-span-5',
  ],
  [
    'row-span-3 col-span-5',
    'row-span-6 col-span-4',
    'row-span-3 col-span-5',
    'col-span-9 row-span-4',
  ],
  [
    'row-span-6 col-span-4',
    'row-span-3 col-span-5',
    'row-span-3 col-span-5',
    'col-span-9 row-span-4',
  ],
  [
    'col-span-5 row-span-5',
    'col-span-4 row-span-4 row-start-2 col-start-6',
    'col-span-4 row-span-4',
    'col-span-5 row-span-5',
  ],
  [
    'col-span-4 row-span-4 row-start-2',
    'col-span-5 row-span-5',
    'col-span-5 row-span-5',
    'col-span-4 row-span-4',
  ],
];
